<div class="progress">
    <div class="indeterminate"></div>
</div>
